import ICharacter from '#/types/characters';
import IStory from '#/types/stories';

export const StoriesActionType = {
  STORIES_SET_STORIES: 'stories/set_stories',
  STORIES_SET_CHARACTERS: 'stories/set_characters',
  STORIES_SET_SELECTED_CHARACTER: 'stories/set_selected_character',
  STORIES_SET_PAGE: 'stories/set_page',
  STORIES_SET_TOTAL_PAGES: 'stories/set_total_pages',
  STORIES_START_LOADING: 'stories/start_loading',
  STORIES_STOP_LOADING: 'stories/stop_loading',
} as const;

export type TStoriesActions =
  | {
      type: typeof StoriesActionType.STORIES_SET_STORIES;
      payload: IStory[];
    }
  | {
      type: typeof StoriesActionType.STORIES_SET_CHARACTERS;
      payload: ICharacter[];
    }
  | {
      type: typeof StoriesActionType.STORIES_SET_SELECTED_CHARACTER;
      payload: ICharacter['id'] | undefined;
    }
  | {
      type: typeof StoriesActionType.STORIES_SET_PAGE;
      payload: number;
    }
  | {
      type: typeof StoriesActionType.STORIES_SET_TOTAL_PAGES;
      payload: number;
    }
  | {
      type: typeof StoriesActionType.STORIES_START_LOADING;
    }
  | {
      type: typeof StoriesActionType.STORIES_STOP_LOADING;
    };
